import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiStar,FiQuote}=FiIcons;

const Testimonials=()=> {
  const testimonials=[ 
    {
      name: "Mara N.",
      business: "Community Church",
      rating: 5,
      text: "Pondering each of the categories and questions was really clarifying as to what's most important to us. The content of our mission statement kept coming to my mind as answers to your questions,and the way the content creation system parsed out my inputs and used them to ask deeper questions generated stuff that felt really authentic to what we're trying to do. I feel equipped to take the next steps in growing our social media presence!"
    },
    {
      name: "Phoebe D.",
      business: "",
      rating: 5,
      text: "John and the CGI team is great to work with,very dependable and a genuine person. He gave me great ideas on advertising and SEO marketing. He also taught me how to generate and work through my own ideas,which I am still benefiting from!"
    },
    {
      name: "M. Rose",
      business: "Small Business Owner",
      rating: 5,
      text: "John and the CGI team designed a website for my small business. I really love the end results. The layout is really nice and professional looking. He had some great ideas and also tailored it to my specificities. John and the CGI team is easy to work with. He went above and beyond to make sure that my website was just what I needed it to be. I would highly recommend him!"
    },
    {
      name: "Samantha K.",
      business: "",
      rating: 5,
      text: "I had a great experience with John and the CGI team in helping to re-do my website + speed it up. I highly recommend!"
    } 
  ];

  return ( 
    <section className="py-20 px-6 bg-white"> 
      <div className="max-w-7xl mx-auto"> 
        <motion.div 
          initial={{opacity: 0,y: 30}} 
          whileInView={{opacity: 1,y: 0}} 
          transition={{duration: 0.8}} 
          viewport={{once: true}} 
          className="text-center mb-16" 
        > 
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"> 
            Success Stories from 
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent block"> 
              Real Business Owners 
            </span> 
          </h2> 
          <p className="text-xl text-gray-600 max-w-3xl mx-auto"> 
            See how entrepreneurs just like you have transformed their businesses with Circle of Goodness<sup className="text-xs">TM</sup>. 
          </p> 
        </motion.div> 

        <div className="grid md:grid-cols-2 gap-8"> 
          {testimonials.map((testimonial,index)=> ( 
            <motion.div 
              key={index} 
              initial={{opacity: 0,y: 30}} 
              whileInView={{opacity: 1,y: 0}} 
              transition={{duration: 0.6,delay: index * 0.1}} 
              viewport={{once: true}} 
              className="bg-gradient-to-br from-white to-gray-50 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 relative" 
            > 
              <SafeIcon icon={FiQuote} className="text-blue-600 text-3xl mb-4 opacity-20 absolute top-6 right-6" /> 
              
              <div className="flex items-center mb-6"> 
                <div> 
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4> 
                  {testimonial.business && ( 
                    <p className="text-gray-600 text-sm">{testimonial.business}</p> 
                  )} 
                  <div className="flex mt-1"> 
                    {[...Array(testimonial.rating)].map((_,i)=> ( 
                      <SafeIcon key={i} icon={FiStar} className="text-yellow-400 text-sm fill-current" /> 
                    ))} 
                  </div> 
                </div> 
              </div> 

              <blockquote className="text-gray-700 leading-relaxed mb-6 italic"> 
                "{testimonial.text}" 
              </blockquote> 
            </motion.div> 
          ))} 
        </div> 

        {/* Overall stats */} 
        <motion.div 
          initial={{opacity: 0,y: 30}} 
          whileInView={{opacity: 1,y: 0}} 
          transition={{duration: 0.8,delay: 0.4}} 
          viewport={{once: true}} 
          className="mt-16 bg-gradient-to-r from-blue-600 to-purple-600 text-white p-8 rounded-2xl shadow-2xl text-center" 
        > 
          <h3 className="text-2xl md:text-3xl font-bold mb-6"> 
            Join Our Community of Successful Business Owners 
          </h3> 
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6"> 
            <div> 
              <div className="text-3xl font-bold">95%</div> 
              <div className="text-sm opacity-90">See Results in 30 Days</div> 
            </div> 
            <div> 
              <div className="text-3xl font-bold">40%</div> 
              <div className="text-sm opacity-90">Average Revenue Increase</div> 
            </div> 
            <div> 
              <div className="text-3xl font-bold">4.9★</div> 
              <div className="text-sm opacity-90">Average Rating</div> 
            </div> 
            <div> 
              <div className="text-3xl font-bold">50+</div> 
              <div className="text-sm opacity-90">Templates and Resources</div> 
            </div> 
          </div> 
        </motion.div> 
      </div> 
    </section> 
  );
};

export default Testimonials;